import { redirectToLogin } from "./annoucement-sheet";
import { api, language } from "./api";
import authHeader from "./auth-header";
import { PaginationData } from "./employee";
export type DropdownDataWithLanguage = {
  id: number;
  name_en: string;
  name_tc: string;
  name_sc: string;
};
type DepartmentsResponse = {
  module_id: number;
  status: boolean;
  data: DepartmentInfo[];
  total: number;
};

export type TData = {
  data: DepartmentInfo[];
  total: number;
};
export type DepartmentInfo = {
  id?: number;
  name: string;
};
type departmentInput = {
  department_ids?:string;
};
export type TaskDepartmentList = {
  SectionList: TaskDepartmentListData[];
};
export type PaginationDepartmentList = {
  departmentList: PaginationDepartmentListData;
};
export type PaginationDepartmentListData = {
  data:TaskDepartmentListData[];
  total: number;
};
export type TaskDepartmentListData = {
  id: number;
  name: string;
};
export type IDepartPaginationData = {
  page: number;
  limit: number | string | undefined;
  search: string | number;
  sort?: string;
};
export const sectionApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSections: build.query<
    any,
    IDepartPaginationData
    >({
      query: ({limit,page,search,sort}) => {
        return ({
          url: `sections?limit=${limit}&page=${page}&search=${search}&sort=${sort}`,
          headers: authHeader(),
        })
      },
      keepUnusedDataFor:0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
    getSectionsWithPagination: build.query<
    PaginationDepartmentList,
    IDepartPaginationData
    >({
      query: ({limit,page,search,sort}) => {
        return ({
          url: `sections?limit=${limit}&page=${page}&search=${search}&sort=${sort}`,
          headers: authHeader(),
        })
      },
      keepUnusedDataFor:0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
    getSectionsAllList: build.query<
    TaskDepartmentList,void
    >({
      query: (department_ids) => ({
        url: `getSectionList`,
        headers: authHeader(),
      }),
      keepUnusedDataFor:0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
    createSection: build.mutation<TaskDepartmentList, DropdownDataWithLanguage>({
      query(body) {
        return {
          headers: authHeader(),
          url: `sections`,
          body,
          method: "POST",
        };
      }
    }),
    getSectionsListByDepartmentIDs: build.mutation<TaskDepartmentList,departmentInput>({
      query({department_ids}) {        
        return {
          headers: authHeader(),
          url: `${department_ids?'getSectionList?department_ids='+department_ids:'getSectionList'} `,
          method: "GET",
        };
      }
    }),
    getSectionsAllListByDepartment: build.query<TaskDepartmentList,departmentInput>({
      query: ({department_ids}) => {
        return{
          url: `${department_ids && department_ids!=='all'?'getSectionList?department_ids='+department_ids:'getSectionList'} `,
          headers: authHeader(),
        }},
      keepUnusedDataFor:0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
    updateSection: build.mutation<TaskDepartmentList, DropdownDataWithLanguage>({
      query(body) {
        return {
          headers: authHeader(),
          url: `sections/${body.id}`,
          body,
          method: "PUT",
        };
      },
      // invalidatesTags: (employees) => {
      //   return [{ type: "Departments", id: "LIST" }];
      // },
    }),
    deleteSection: build.mutation<TaskDepartmentList, number>({
      query(id) {
        return {
          headers: authHeader(),
          url: `/sections/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: (employees) => {
        return [{ type: "Sections", id: "LIST" }];
      },
    }),
    deleteSubMenu: build.mutation<any, number>({
      query:(id)=> {
        console.log("id ",id)
        return {
          headers: authHeader(),
          url: `/menus/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: () => [{ type: 'Header' }],
    }),
  }),
});

export const {
  useGetSectionsQuery,
  useCreateSectionMutation,
  useUpdateSectionMutation,
  useDeleteSectionMutation,
  useGetSectionsAllListQuery,
  useDeleteSubMenuMutation,
  useGetSectionsListByDepartmentIDsMutation,
  useGetSectionsAllListByDepartmentQuery
} = sectionApi;

export const {
  endpoints: {
    getSections,
    createSection,
    updateSection,
    deleteSection,
    getSectionsAllList,
    getSectionsWithPagination,
    deleteSubMenu,
    getSectionsListByDepartmentIDs,
    getSectionsAllListByDepartment
  },
} = sectionApi;
